import { useEffect, useState } from 'react';
import './Contact.css';
import emailjs from '@emailjs/browser';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', organization: '', interest: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    emailjs.init('Y2SpiZe-UsLY-Lmxe');
  }, []);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Name is required';
    if (!form.email.trim()) e.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Enter a valid email';
    if (!form.phone.trim()) e.phone = 'Phone number is required';
    if (!form.organization.trim()) e.organization = 'Organisation is required';
    return e;
  };

  const handleChange = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
    if (errors[e.target.name]) setErrors(er => ({ ...er, [e.target.name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errs = validate();

    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }

    setLoading(true);

    const templateParams = {
      product_name: 'Aiva',

      full_name: form.name,
      email: form.email,

      company: form.organization,

      role: 'AI Chatbot Enquiry',

      // Reusing common template fields
      size: form.phone || 'Not Provided',

      interest: form.interest || 'Custom AI Agent',

      message: `
Phone Number: ${form.phone}

Use Case:
${form.message || 'No additional details provided'}
    `
    };

    try {
      // Admin notification
      await emailjs.send(
        'service_ioywtjd',
        'template_exkeoo4',
        templateParams
      );

      // User confirmation
      await emailjs.send(
        'service_ioywtjd',
        'template_09t0zzd',
        templateParams
      );

      setSubmitted(true);

      setForm({
        name: '',
        email: '',
        phone: '',
        organization: '',
        interest: '',
        message: ''
      });

    } catch (error) {
      console.error('EmailJS Error:', error);
      alert('Unable to send email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="section-divider">
      <div className="section-wrap">
        <div className="contact__grid">
          {/* Left info */}
          <div className="contact__info">
            <span className="eyebrow">Get in touch</span>
            <h2 className="sec-title">Let's build your AI agent.</h2>
            <p className="sec-sub">
              Tell us which bot you need — or describe your use case — and our team will
              get back to you within one business day with a tailored proposal.
            </p>

            <div className="contact__details">
              <div className="contact-detail">
                <div className="contact-detail__icon">📧</div>
                <div>
                  <div className="contact-detail__label">Email us directly</div>
                  <a href="mailto:info@aiprus.com" className="contact-detail__val">
                    info@aiprus.com
                  </a>
                </div>
              </div>
              <div className="contact-detail">
                <div className="contact-detail__icon">📞</div>
                <div>
                  <div className="contact-detail__label">Call us</div>
                  <a href="tel:+918420006452" className="contact-detail__val">
                    +91-842-000-6452
                  </a>
                </div>
              </div>
              <div className="contact-detail">
                <div className="contact-detail__icon">🌐</div>
                <div>
                  <div className="contact-detail__label">Visit our website</div>
                  <a href="https://www.aiprus.com" target="_blank" rel="noreferrer" className="contact-detail__val">
                    www.aiprus.com
                  </a>
                </div>
              </div>
            </div>

            <div className="contact__bots-list">
              <p className="contact__bots-title">What we can build for you:</p>
              {['HR Assistant Bot', 'Sales & Marketing Bot', 'IT Helpdesk Bot', 'Finance & Expense Bot',
                'Employee Onboarding Bot', 'Vendor & Procurement Bot', 'Customer Support Bot', 'Custom Domain Bot'].map(b => (
                  <div key={b} className="contact__bot-item">
                    <span className="contact__bot-check">✓</span>{b}
                  </div>
                ))}
            </div>
          </div>

          {/* Right form */}
          <div className="contact__form-wrap">
            {submitted ? (
              <div className="contact__success">
                <div className="success-icon">🎉</div>
                <h3>Thank you, {form.name.split(' ')[0]}!</h3>
                <p>We've received your enquiry from <strong>{form.organization}</strong>. Our team will reach out to <strong>{form.email}</strong> within one business day.</p>
              </div>
            ) : (
              <form className="contact__form" onSubmit={handleSubmit} noValidate>
                <h3 className="contact__form-title">Request a demo</h3>
                <p className="contact__form-sub">Fill in your details and we'll tailor a demo to your exact use case.</p>

                <div className="form-row">
                  <div className={`form-field ${errors.name ? 'form-field--error' : ''}`}>
                    <label>Full name <span>*</span></label>
                    <input type="text" name="name" placeholder="Rajesh Kumar" value={form.name} onChange={handleChange} />
                    {errors.name && <span className="form-error">{errors.name}</span>}
                  </div>
                  <div className={`form-field ${errors.email ? 'form-field--error' : ''}`}>
                    <label>Work email <span>*</span></label>
                    <input type="email" name="email" placeholder="rajesh@company.com" value={form.email} onChange={handleChange} />
                    {errors.email && <span className="form-error">{errors.email}</span>}
                  </div>
                </div>

                <div className="form-row">
                  <div className={`form-field ${errors.phone ? 'form-field--error' : ''}`}>
                    <label>Phone number <span>*</span></label>
                    <input type="tel" name="phone" placeholder="+91 98765 43210" value={form.phone} onChange={handleChange} />
                    {errors.phone && <span className="form-error">{errors.phone}</span>}
                  </div>
                  <div className={`form-field ${errors.organization ? 'form-field--error' : ''}`}>
                    <label>Organisation <span>*</span></label>
                    <input type="text" name="organization" placeholder="Acme Technologies Pvt Ltd" value={form.organization} onChange={handleChange} />
                    {errors.organization && <span className="form-error">{errors.organization}</span>}
                  </div>
                </div>

                <div className="form-field">
                  <label>Bot of interest</label>
                  <select name="interest" value={form.interest} onChange={handleChange}>
                    <option value="">Select a bot (optional)</option>
                    <option>HR Assistant Bot</option>
                    <option>Sales & Marketing Bot</option>
                    <option>IT Helpdesk Bot</option>
                    <option>Finance & Expense Bot</option>
                    <option>Employee Onboarding Bot</option>
                    <option>Vendor & Procurement Bot</option>
                    <option>Customer Support Bot</option>
                    <option>Custom Domain Bot</option>
                    <option>Multiple bots / Enterprise package</option>
                  </select>
                </div>

                <div className="form-field">
                  <label>Tell us about your use case</label>
                  <textarea
                    name="message" rows={4}
                    placeholder="Describe your current challenge or what you'd like the bot to do..."
                    value={form.message} onChange={handleChange}
                  />
                </div>

                <button
                  type="submit"
                  className="btn-teal contact__submit"
                  disabled={loading}
                >
                  {loading ? 'Sending...' : 'Send enquiry →'}
                </button>
                <p className="form-privacy">By submitting this form you agree to our Privacy Policy. We'll never share your details.</p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
